__webpack_require__.p = "https://www.spadej.com.tw/";